import {MITTWALD_API, Schemas} from '../middleware/MittwaldApi'
import * as ActionTypes from '../constants/ActionTypes'
import {queryBearerToken} from './UserAuthentication'

// **************************************************************************************************************
const fetchSoftwareData = (bearer) => ({
    [MITTWALD_API]: {
        types: [ActionTypes.SOFTWARE_REQUEST, ActionTypes.SOFTWARE_SUCCESS, ActionTypes.SOFTWARE_FAILURE],
        endpoint: `software`,
        bearer: bearer,
        schema: Schemas.SOFTWARE,
        method: 'GET'
    }
})

export const querySoftwareData = () => (dispatch, getState) => {
    return dispatch(queryBearerToken()).then(() => {
        return dispatch(fetchSoftwareData(getState().token.bearer))
    })
}

/*
const selectSoftwareOption = (softwareSelected) => ({
	type: ActionTypes.SELECT_SOFTWARE,
	selected: softwareSelected
})

export const querySoftwareSelect = (softwareSelected) => (dispatch, getState) => {
	dispatch(selectSoftwareOption(softwareSelected))
	return dispatch(putFormData())
}
*/



/** WEBPACK FOOTER **
 ** ./src/actions/SoftwareSelect.js
 **/